// https://volt.primevue.org/nuxt/

import PrimeVue from 'primevue/config';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(PrimeVue, {
    unstyled: true
  });
});
